module.exports = __webpack_public_path__ + "static/media/header.fd0c7807.png";